import React from "react";
import theme from "@monorepo/styles/theme";
import { Box, BoxProps, styled } from "@mui/material";
import { SxProps } from "@mui/system";

interface IThirdPartyImgWrapper extends BoxProps {
  sx?: SxProps;
  src: string;
  alt: string;
}

export const ThirdPartyImgWrapper = styled(Box)<IThirdPartyImgWrapper>(() => ({
  height: "360px",
  width: "320px",
  maxWidth: "320px",
  [theme.breakpoints.up("md")]: {
    height: "320px",
    maxWidth: "420px",
    width: "420px",
  },
}));

export const ThirdPartyImageWrapper: React.FC<IThirdPartyImgWrapper> = ({ children, ...rest }) => {
  return <ThirdPartyImgWrapper {...rest}>{children}</ThirdPartyImgWrapper>;
};
